import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileResBody,
  TDeviceProfileSummaryResBody,
  TDeviceSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfilesClient = {
  get(id: string): Promise<TEntityResponse<'device-profile', TDeviceProfileResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile', TDeviceProfileSummaryResBody> | undefined>;
  list_dp_devices(id: string): Promise<TEntityListResponse<'device', TDeviceSummaryResBody> | undefined>;
};

function DeviceProfilesClient(apiClient: TAPIClient): TDeviceProfilesClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile', TDeviceProfileResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile', TDeviceProfileResBody>>(
        `/device-profiles/${id}`
      );

      if (data && data.type !== 'device-profile') {
        throw new Error('Invalid entity type received, expected: device-profile, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile', TDeviceProfileSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'device-profile', TDeviceProfileSummaryResBody>>(
        `/device-profiles?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'device-profile') {
        throw new Error('Invalid entity type received, expected: device-profile, received: ' + data.type);
      }

      return data;
    },

    async list_dp_devices(id: string): Promise<TEntityListResponse<'device', TDeviceSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'device', TDeviceSummaryResBody>>(
        `/device-profiles/${id}/devices`
      );

      if (data && data.type !== 'device') {
        throw new Error('Invalid entity type received, expected: device, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfilesClient, DeviceProfilesClient };
